<template>
  <modal :name="'popupModal'+popIndex"
         :ref="'popupModal'+popIndex"
         :width=imgWidth
         :height=imgHeight
         :draggable="isDraggable"
         :resizable="false"
         :reset="true"
         :scrollable="true"
         :clickToClose="false"
         :adaptive="true"
         :shiftX=this.left
         :shiftY=this.top
         @opened="this.change"
  >
    <div id="layer-popup">
      <div class="popup-header">
        <h2 class="txt-ellipsis">{{popTitle}}</h2>
        <button type="button" class="popup-close" @click="popupTodayClose($event, popIndex)">
          <img src="../../assets/img/popup_close.png" alt="팝업닫기" title="팝업닫기">
        </button>
      </div>
      <div :class="this.isImagePopup? 'popup-cnt': 'popup-cnt-txt'">
        <div class="img-area" v-html="popImg"></div>
        <div class="popup--option">
          <input type="checkbox" v-model="isCheckedTodayClose" style="width:20px;height:20px;" id="chk" name="chk">
          <label for="chk">하루동안 보지 않기</label>
          <button type="button" class="popup-close" @click="popupTodayClose($event, popIndex)" style="margin-left:10px;"> [닫기] </button>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import Cookies from 'js-cookie'
import CommonUtil from '@/assets/js/commonUtil'
import draggable from "vuedraggable";

export default {
  name: 'MainPopupNew',
  props: {
    boardId: {
      type: String,
      default: ''
    },
    popList: {},
    imgWidth: {
      type: Number,
      default: 0
    },
    imgHeight: {
      type: Number,
      default: 0
    },
    popIndex: {
      type: Number,
      default: 0
    },
    popTitle: {
      type: String,
      default: ''
    },
    popImg: {
      type: String,
      default: ''
    },
    left: {
      type: Number,
      default: 0.5
    },
    top: {
      type: Number,
      default: 0.5
    },
    isDraggable: {
      type: Boolean,
      default: true
    },
    isImagePopup: {
      type: Boolean,
      default: true
    },
  },
  data () {
    return {
      isCheckedTodayClose: false,
      titleFont: 'font-size:20px;font-weight:600;padding:10px 0;',
      cntFont: 'font-size:14px'
    }
  },
  created () {
  },
  mounted () {
    const popupOpenDate = new Date(this.popList.popStartDate.replace(/,/g, '-'))
    const popupEndDate = new Date(this.popList.popEndDate.replace(/,/g, '-'))
    const toDate = new Date()

    if (popupOpenDate.getTime() <= toDate.getTime() && toDate.getTime() <= popupEndDate.getTime()) {
      const popupCloseDay = Cookies.get(this.boardId)
      const toDay = CommonUtil.getFormatDate(new Date(), '')
      if (!popupCloseDay) {
        this.showPopup(this.popIndex)
      } else {
        if (popupCloseDay === toDay) {
          this.closePopup(this.popIndex)
        } else {
          Cookies.remove(this.boardId)
          this.showPopup(this.popIndex)
        }
      }
    }
  },
  methods: {
    showPopup (idx) {
      this.$modal.show('popupModal' + idx, {}, {styles: { transform: 'none', top: '80px', left: '120px', position: 'fixed' }})
    },

    closePopup (idx) {
      this.$modal.hide('popupModal' + idx)
    },

    popupTodayClose (event, idx) {
      this.$nextTick(function () {
        if (event) event.preventDefault()
        if (this.isCheckedTodayClose) {
          Cookies.set(this.boardId, CommonUtil.getFormatDate(new Date(), ''))
        }
        this.closePopup(idx)
      })
    },

    change (event, idx) {
      // const popupModal = document.querySelector('div[data-modal="'+ event.name +'"]');
      // if (popupModal) {
      //
      //   const nextSibling = popupModal.nextElementSibling;
      //   console.log(nextSibling);
      //
      //   if (nextSibling) {
      //     nextSibling.style.left = this.left + 'px';
      //     nextSibling.style.top = this.top + 'px';
      //   }
      // }
    }
  }
}
</script>

<style scoped>
.vm--container {
  width: 0px;
  height: 0px;
  z-index: 1000;
}
.vm--modal{
  left: 0;
  top: 0;
  pointer-events: none !important;
}
.direct-link{
  width:auto !important;
  border: 2px solid #5a57aa;
  padding:10px 15px;
  display: inline-block;
  margin:20px 0;
}
.link:hover{
  color:#5a57aa;
  text-decoration: underline;
}
#layer-popup{position: absolute;width:100%;height:100%;border: 1px solid #acacac;background-color: #f7f7f7;}
#layer-popup .popup-header{position: relative;width:100%;height:55px;line-height: 55px;background-color: #5a57aa;padding:0 20px;}
#layer-popup .popup-header h2{color:#ffffff;font-weight: 500;font-size: 17px;padding-left:8px;width:92%;}
#layer-popup .popup-header .popup-close{position: absolute;top:16px;right:21px;}
#layer-popup .popup-option{width:100%;height:51px;line-height: 52px; border-width: 1px 0 1px 0;border-style: solid;border-color:#d3d3d3;background-color: #ffffff;padding:0 20px;}
#layer-popup .popup-option .tip{font-size: 12px;color:#5a57aa;font-weight: 400;background: url("../../assets/img/popup/icon_popup_close.png") no-repeat 0 center;padding-left: 24px;float:left;}
#layer-popup .popup-option .zoom-option{float:right;}
#layer-popup .popup-option .zoom-option li{float:left;}
#layer-popup .popup-option .zoom-option li button{width:32px;height:23px;border: 1px solid #8a9faf;box-sizing: border-box;padding:4px 0 0 2px}
#layer-popup .popup-option .zoom-option li .zoom-up{border-radius: 10px 0 0 10px;}
#layer-popup .popup-option .zoom-option li .zoom-down{border-radius: 0 10px 10px 0;}
#layer-popup .popup-cnt-txt{background-color: #ffffff;padding:30px;width:100%;height:calc(100% - 90px);overflow: auto;overflow-x: hidden;text-align:left}
#layer-popup .popup-cnt-txt > div{width:100%;}
#layer-popup .popup-cnt{background-color: #ffffff;padding:0;width:100%;height:100%;overflow: auto;overflow-x: hidden;text-align:center}
#layer-popup .popup-cnt > div{width:100%;}
#layer-popup .popup-cnt .graph02{margin-top:12px;}
#layer-popup .popup-cnt ::v-deep img{max-width: 100%;}
.popup--option > *{font-weight: 400;}
.vm--overlay[data-modal="popupModal"] {
  width: 0px;
  height: 0px;
  background: transparent;
}
.qr-code{
  /* border: 1px solid #5a57aa;
  padding:10px; */
  /* width:220px !important;
  height:220px; */
  text-align: center;
}
.popup--option{
  position: absolute;
  bottom:0;
  /* text-align: right; */
  display: flex;
  justify-content: flex-end;
  align-items: center;
  background-color: #ffffff;
  left: 0;
  height: 35px;
  padding:0 10px;
  border-top: 1px solid #cccccc;
}
.popup--option > *{
  font-size: 16px;
}
.popup--option input[type='checkbox']{
  margin-right:6px;
}
.img-area{
  /* display: flex;
  align-content: flex-start;
  align-items:end; */
}
.txt-ellipsis {
  max-width: 100%;          /* 부모 폭에 맞춰 자르기 */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

</style>
<style>
.vm--overlay{
  pointer-events: none !important;
}
.vm--overlay[data-modal^="popupModal"] {
  width: 0px;
  height: 0px;
  background: transparent;
}
</style>
